export const SET_PRIMARY_GRANULARITY = 'SET_PRIMARY_GRANULARITY';
export const SET_SECONDARY_GRANULARITY = 'SET_SECONDARY_GRANULARITY';
export const SET_CURRENT_DATES = 'SET_CURRENT_DATES';
export const RESET_DIGITAL_TWIN_STATE = 'RESET_DIGITAL_TWIN_STATE';